export enum BottomNavClickActionsNames {
    Menu = 'menu',
    Betslip = 'toggleBetslip',
    Bets = 'toggleMyBets',
}
